import React, { FC } from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';
import { PaddingBox } from '../../../../../../ReactSharedScripts/components/PaddingBox';

export type DetailLayoutProps = {
	className?: string;
	dataTestId?: string;
	size?: 'stretch' | 'large' | 'small';
};

export const Layout: FC<React.PropsWithChildren<DetailLayoutProps>> = ({ className, children, size, dataTestId }) => {
	const componentClasses = classNames(classes.layout, classes[`layout_${size}`], className);

	return (
		<PaddingBox
			hrMedium
			className={componentClasses}
			dataTestId={dataTestId}
		>
			{children}
		</PaddingBox>
	);
};

Layout.defaultProps = {
	size: 'stretch',
};
